<template>
  <div id="app">
    <div class="" v-if="true">
      <div class="container-fluid">
        <div class="row">
          <div class="col col-sm-4 offset-sm-1">
            <img src="./assets/img/banner_left.png" class="img-fluid float-start mt-3" height="100%">
          </div>
          <div class="w-100 d-block d-sm-none"></div>
          <div class="col col-sm-6">
            <h1 class="ms-auto my-auto fw-bold text-sm-right p-3" v-html="getTitle()"></h1>
          </div>
        </div>
      </div>
      <div class="bg-transparent border-bottom-2 border-danger">
        <nav class="col-10 offset-1 navbar navbar-expand-lg navbar-light pb-0 ps-2 pe-2">
          <ul class="navbar-nav me-auto mt-lg-0" v-if="login.success === false">
            <li class="nav-item">
              <router-link class="nav-link" to="/login">
                <icon :icon="['fad', 'right-to-bracket']"/>
                Login
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav me-auto mt-lg-0" v-if="login.success">
            <li class="nav-item">
              <router-link class="nav-link" to="/home">
                <icon :icon="['fad', 'house']"/>
                <!--                {{wording[0].navigation.home}}--> Home
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav nav-pills" v-if="login.success">
            <li class="nav-item">
              <a class="nav-link" href="#" v-on:click="logout()">
                <icon :icon="['fad', 'right-from-bracket']"/>
                <!--                {{wording[0].navigation.logout}}--> Logout
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="border-bottom border-dark bg-primary d-flex sticky-top">
        <div class="col-10 offset-1 ps-1 pe-1 mx-auto" id="submenu">
          <submission-steps v-if="$route.path.includes('/poster/')"></submission-steps>
          <general-navigation v-else></general-navigation>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row" style="min-height: 350px;">
          <div class="col col-lg-10 offset-lg-1 mt-2">
            <router-view/>
          </div>
          <!--          <div class="col col-lg-10 offset-lg-1 mt-2 text-center" v-else>-->
          <!--            <Loader></Loader>-->
          <!--            Please wait while your submissions are loaded.-->
          <!--          </div>-->
        </div>
      </div>
      <div class="text-center pt-1 mt-2 pb-1 border-top">
        <div class="mt-3 mb-1">

          <div style="margin-left:auto;margin-right:auto;width:240px;border:1px solid #d4d4d4;border-radius:6px;padding:12px 12px 12px 12px;text-align: center;">
            <a href="https://documedias.com" class="" target="_blank">
              <img src="./assets/img/powered.svg" style="height:20px;">
            </a>
          </div>

        </div>
        <div class="small">
          <a href="https://www.abstractserver.com/datenschutz/imprint.html#eng" target="_blank"
             class="">Imprint</a> - <a
            href="https://www.abstractserver.com/datenschutz/data_security_agreement.html#eng" target="_blank"
            class="">Data Security
          Agreement</a>
        </div>
        <!--
        <div class="mt-3 mb-1">
          <a href="http://posterwalk.com" class="" target="_blank">
            <div >
              <img src="./assets/img/poster_walk.jpg" style="height:20px;">
            </div>
          </a>
        </div>
        -->
      </div>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import GeneralNavigation from "@/views/navbars/GeneralNavigation";
import SubmissionSteps from "@/views/navbars/SubmissionSteps";
// import SubmissionSteps from "./views/navbars/SubmissionSteps";

export default {
  components: {SubmissionSteps, GeneralNavigation},
  computed: mapState(["login", 'user', 'prefilledToken']),
  mounted() {
    this.$store.dispatch('GET_ALL_STATUS');
    // this.$store.dispatch('GET_ALL_TYPES');
    this.$store.dispatch('GET_ALL_SUBMISSIONS');
    this.$store.dispatch('GET_ALL_PAGES');
    // this.$store.dispatch('GET_ALL_COUNTRIES');
    this.$store.dispatch('GET_ALL_WORDING', this.language);
    //
    // if (this.login.success === false) {
    //   this.$router.push('/login');
    // }
  },
  methods: {
    getTitle() {
      return process.env.VUE_APP_TITLE
    },
    logout() {
      this.login.success = false;
      localStorage.removeItem('token');
      localStorage.removeItem('eposter-token');
      localStorage.removeItem('x-api-key');
      this.$router.push('/login');
      this.$store.dispatch('SET_PREFILLED_TOKEN', {'prefiledToken': null});

    },
    changeLanguage(language) {
      this.$store.dispatch('GET_ALL_WORDING', language);
    },

  }
}
</script>

<style lang="scss">
@import './assets/styles/custom-bootstrap.scss';
@import './assets/styles/radial_progress.scss';
@import "~bootstrap/scss/bootstrap";
</style>
